import { Files } from '../../lib/constants/files'
import { Quotation } from '../../lib/types/models/quotation/quotation'
import { QuotationRequest } from '../../lib/types/models/quotation/quotation-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createQuotation = async (input: QuotationRequest) => {
  const uploadedFile = await uploadFile(Files.QUOTATION_FILE, input.file)
  if (uploadedFile) input.file = uploadedFile
  else throw new Error('File not uploaded')

  return restApiClient
    .url(constructApiUrl(API.quotation.create.url, null))
    .post<Quotation, QuotationRequest>(input)
}
